module.exports = __webpack_public_path__ + "img/limitation.cb39432.svg";